import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { Map } from 'components/common/GoogleMaps'
import SavedLocationSearchForm from 'components/common/SavedLocationSearchForm'
import { LOCATION_FINDER_HINT_ID } from 'constant'
import {
  MAP_DEFAULTS,
  DEFAULT_LOCATION_FINDER_HEADER_TEXT
} from './constants'

const SavedLocationEmpty = ({
  isGeolocationAvailable,
  isGeolocationEnabled,
  coords,
  locationFinderTitle = DEFAULT_LOCATION_FINDER_HEADER_TEXT,
  findMyStoreInstruction,
  findStoreHandleSubmit,
  ...props
}) =>
  <Wrapper>
    <MapContainer>
      {
        isGeolocationAvailable && isGeolocationEnabled && coords ?
          <Map defaultCenter={ coords } /> :
          <Map { ...MAP_DEFAULTS } />
      }
    </MapContainer>

    <LocationFinderContainer>
      <LocationFinder>
        <Header data-at-location-finder-text>{ locationFinderTitle }</Header>
        <Hint id={ LOCATION_FINDER_HINT_ID } data-at-location-hint>
          { findMyStoreInstruction }
        </Hint>
        <ActionWrapper>
          <SavedLocationSearchForm
            { ...props }
            disableErrors
            onSubmit={ findStoreHandleSubmit } />
        </ActionWrapper>
      </LocationFinder>
    </LocationFinderContainer>

  </Wrapper>

SavedLocationEmpty.propTypes = {
  coords: PropTypes.shape(),
  findMyStoreInstruction: PropTypes.string,
  findStoreHandleSubmit: PropTypes.func,
  isGeolocationAvailable: PropTypes.bool,
  isGeolocationEnabled: PropTypes.bool,
  locationFinderTitle: PropTypes.string
}

export default SavedLocationEmpty

const Wrapper = styled.div`
  text-align: left;
  padding: 10px 0;
  ${Media.desktop`
    position: relative;
    padding: 0;
    ${Mixin.clearFix()}
  `}
`

const MapContainer = styled.div`
  height: 398px;
  ${Mixin.desktopOnly()}
`

const LocationFinderContainer = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  `}
`

const LocationFinder = styled.div`
  ${Media.desktop`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 28px 26px;
    width: 34.43em;
    min-height: 218px;
    background-color: ${Theme.colors.white};
    box-shadow: 0 0 2px ${Theme.colors.transparent_grey_hover};
  `}
`

const Header = styled.h2`
  ${Mixin.font.GothamBold(14)}
  color: ${Theme.colors.black};
  margin-top: 0;
`

const Hint = styled.p`
  color: ${Theme.colors.black};
`

const ActionWrapper = styled.div`
  ${Mixin.responsive('padding-top', '22px', '10px')}
  ${Mixin.clearFix()}
`
